import React from "react";

const ServiceArea = () =>{
    return(
        <>
        {/* SERVICE AREA START */}
        <div className="service sp">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 m-auto text-center">
                <div className="heading1">
                  <span className="span" data-aos="zoom-in-left" data-aos-duration="700"><img src="/assets/img/icons/span1.png" alt=""/> Our Services</span>
                  <h2 className="title tg-element-title">Empower your business with our comprehensive solutions</h2>
                </div>
              </div>
            </div>

            <div className="space30"></div>
            <div className="row">
              <div className="col-lg-6" data-aos="zoom-in-up" data-aos-duration="700">
                <div className="single-box">
                  <div className="icon">
                    <img src="/assets/img/icons/service-icon1.png" alt=""/>
                  </div>
                  <div className="heading1">
                    <h4><a href="service-details.html">Real-Time & Accurate Forex Data</a></h4>
                    <div className="space16"></div>
                    <p>Our API ensures zero-delay exchange rate updates from trusted global sources.</p>
                    <div className="space16"></div>
                    {/* <a href="service-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a> */}
                  </div>
                </div>
              </div>

              <div className="col-lg-6" data-aos="zoom-in-up" data-aos-duration="1100">
                <div className="single-box">
                  <div className="icon">
                    <img src="/assets/img/icons/service-icon2.png" alt=""/>
                  </div>
                  <div className="heading1">
                    <h4><a href="service-details.html">Comprehensive Currency Coverage</a></h4>
                    <div className="space16"></div>
                    <p>Our Fx API Supports all major & exotic currency pairs with bid-ask spread values.</p>
                    <div className="space16"></div>
                    {/* <a href="service-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a> */}
                  </div>
                </div>
              </div>

              <div className="col-lg-4" data-aos="zoom-in-up" data-aos-duration="800">
                <div className="single-box">
                  <div className="icon">
                    <img src="/assets/img/icons/service-icon3.png" alt=""/>
                  </div>
                  <div className="heading1">
                    <h4><a href="service-details.html">Historical Data for Market Insights</a></h4>
                    <div className="space16"></div>
                    <p>Get access to past exchange rates, OHLC data, and moving averages for better decision-making.</p>
                    <div className="space16"></div>
                    {/* <a href="service-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a> */}
                  </div>
                </div>
              </div>

              <div className="col-lg-4" data-aos="zoom-in-up" data-aos-duration="1200">
                <div className="single-box">
                  <div className="icon">
                    <img src="/assets/img/icons/service-icon4.png" alt=""/>
                  </div>
                  <div className="heading1">
                    <h4><a href="service-details.html">Customization as per user requirement</a></h4>
                    <div className="space16"></div>
                    <p>Tailor exchange rate data to your needs with our customizable API, designed to adapt to your specific requirements.</p>
                    <div className="space16"></div>
                    {/* <a href="service-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a> */}
                  </div>
                </div>
              </div>


              <div className="col-lg-4" data-aos="zoom-in-up" data-aos-duration="900">
                <div className="single-box">
                  <div className="icon">
                    <img src="/assets/img/icons/service-icon5.png" alt=""/>
                  </div>
                  <div className="heading1">
                    <h4><a href="service-details.html">Developer-Friendly & Easy Integration</a></h4>
                    <div className="space16"></div>
                    <p>A plug & play Exchange Rate API with clear documentation, multiple SDKs, ready-to-use sample code snippets</p>
                    <div className="space16"></div>
                    {/* <a href="service-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a> */}
                  </div>
                </div>
              </div>


              <div className="col-lg-6" data-aos="zoom-in-up" data-aos-duration="900">
                <div className="single-box">
                  <div className="icon">
                    <img src="/assets/img/icons/service-icon5.png" alt=""/>
                  </div>
                  <div className="heading1">
                    <h4><a href="service-details.html">99.99% Uptime & Lightning-Fast Response</a></h4>
                    <div className="space16"></div>
                    <p>Reliable servers ensure instantaneous data retrieval, even during high-traffic hours.</p>
                    <div className="space16"></div>
                    {/* <a href="service-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a> */}
                  </div>
                </div>
              </div>


              <div className="col-lg-6" data-aos="zoom-in-up" data-aos-duration="900">
                <div className="single-box">
                  <div className="icon">
                    <img src="/assets/img/icons/service-icon5.png" alt=""/>
                  </div>
                  <div className="heading1">
                    <h4><a href="service-details.html">Flexible Pricing & Free Plan</a></h4>
                    <div className="space16"></div>
                    <p>Free Plan available so businesses can test before committing, with competitive pricing for all needs.</p>
                    <div className="space16"></div>
                    {/* <a href="service-details.html" className="learn">Learn More <span><i className="fa-solid fa-arrow-right"></i></span></a> */}
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>

        {/* SERVICE AREA END */}
        </>
    )
}

export default ServiceArea;